import { styled as t, Box as r, Typography as i } from "@mui/material";
import s from "../../temp-lib/components/share/next/Image.js";
import { noForwardProps as x } from "../../temp-lib/util/styled/index.js";
import { jsxs as a, jsx as o } from "react/jsx-runtime";
const g = t(r)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  width: 800px;
`, h = t(s)`
  @keyframes image-shadowing {
    50% {
      filter: drop-shadow(0px 0px 10px rgb(234, 240, 243));
    }
  }

  animation: image-shadowing 2s infinite;
  aspect-ratio: 500/421;

  ${(e) => e.theme.breakpoints.up("res480")} {
    width: 480px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    margin-top: 30px;
    width: 290px;
  }
`, u = t(r)`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;

  ${(e) => e.theme.breakpoints.up("res480")} {
    margin-top: -120px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    margin-top: -60px;
  }
`, p = t(s)`
  aspect-ratio: 290 / 40;
  height: 100%;
`, w = t(r, x)`
  align-items: center;
  background-color: ${(e) => e.__color};
  display: flex;
  padding: 8px 25px;
  box-shadow: 0px 0px 5px #333333;
`, k = t(p)`
  transform: scaleX(-1);
`, b = t(r)`
  background-color: red;
  background: radial-gradient(#316a7533, transparent);
  bottom: 6px;
  height: 100px;
  position: absolute;
  width: 100%;
`, C = t(i)`
  background: linear-gradient(
    180deg,
    #ffffff 15%,
    #ffffff 40%,
    #a3ffe2 60%,
    #a3ffe2 80%
  );
  background-clip: text;
  filter: drop-shadow(2px 5px 5px #333333);
  font-weight: 500;
  -webkit-text-fill-color: transparent;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 60px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 38px;
  }
`, y = t(i)`
  color: #91edff;
  text-shadow: 0px -2px 10px #283451;
  text-transform: capitalize;
  white-space: nowrap;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 18px;
    font-weight: 400;
    line-height: 18px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
  }
`, z = (e) => {
  const {
    className: c,
    barColor: l,
    barSide: n,
    logo: d,
    title: f,
    name: m
  } = e;
  return /* @__PURE__ */ a(g, {
    className: c,
    children: [/* @__PURE__ */ o(h, {
      className: "Custom-Logo",
      src: d
    }), /* @__PURE__ */ o(b, {}), /* @__PURE__ */ a(u, {
      className: "Custom-Title-Background",
      children: [/* @__PURE__ */ o(p, {
        src: n
      }), /* @__PURE__ */ o(w, {
        __color: l,
        className: "Custom-Title-Background-Center",
        children: /* @__PURE__ */ o(y, {
          className: "Custom-Title",
          children: f
        })
      }), /* @__PURE__ */ o(k, {
        src: n
      })]
    }), /* @__PURE__ */ o(C, {
      className: "Custom-Colored-Text",
      children: m
    })]
  });
};
export {
  z as default
};
//# sourceMappingURL=DownloadLogo.js.map
